import { Plan, usePlansService } from 'nekst-api';
import React from 'react';
import { PlanPermission, useAuthorizationChecker } from 'authorization-scope';
import { usePopupFormManager } from 'features/nekst-widgets';
import { ButtonSize, OptionSelectionButton } from 'ui-builder';
import { RenamePlanForm } from 'features/tasks-forms';
import DeleteGlobalPlanForm from './DeleteGlobalPlanForm';
import { CopyToGlobalPlanForm } from './CopyToGlobalPlanForm';
import { ChangeGlobalPlanTypeForm } from './ChangeGlobalPlanTypeForm';
import { useStateContext } from '../../../../settings/administration/markets/StateContext';

export function AdminPlanButtons(
  props: {
    plan: Plan,
    setupAreaId: number,
    setupAreaVersion: string
  }
) {

  const { isGranted } = useAuthorizationChecker();

  const popupManager = usePopupFormManager();

  const planService = usePlansService();

  const { id: state} = useStateContext();

  return (
    <OptionSelectionButton
      text="Edit"
      options={[
        isGranted(PlanPermission.UPDATE) && {
          value: 'rename',
          label: 'Rename',
          onSelected: () => {
            popupManager.openForm(
              <RenamePlanForm id={props.plan.id} />,
              true,
            );
          },
        },
      {
          value: 'change_type',
          label: 'Change type',
          onSelected: async () => {
            const plan = await planService.getById(props.plan.id);

            popupManager.openForm(
              <ChangeGlobalPlanTypeForm plan={plan} />,
            );
          }
        },
        {
          value: 'delete',
          label: 'Delete workflow',
          onSelected: () => {
            popupManager.openForm(
              <DeleteGlobalPlanForm
                state={state}
                planId={props.plan.id}
                setupAreaId={props.setupAreaId}
                setupAreaVersion={props.setupAreaVersion}
              />,
            );
          }
        },
        isGranted(PlanPermission.COPY_TO_GLOBAL_PLAN) && {
          value: 'copy',
          label: 'Copy as global workflow',
          onSelected: () => {
            popupManager.openForm(
              <CopyToGlobalPlanForm plan={props.plan} />
            )
          }
        }
      ]}
      size={ButtonSize.MEDIUM}
    />
  );
}
